module.exports = __webpack_public_path__ + "img/9sGkm70z5tw_thumb.40f7e4ca.png";